import { serviceRoles } from "config/access";
import { CAREER } from "constants/routes";
import { checkAccess } from "helpers/auth";
import CareerPage from "./container/CareerPage";

export default function getSettingsRoute(userAuth) {
  const { account, cpfm } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin],
    [cpfm.name]: [cpfm.roles.admin],
  };
  return {
    path: CAREER,
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    withSidebar: false,
    withAppBar: true,
    component: CareerPage,
  };
}
